package com.zaurh.mapquizwebsite.data.service

import io.ktor.client.HttpClient
import io.ktor.client.plugins.expectSuccess
import io.ktor.client.request.get
import io.ktor.client.request.post
import io.ktor.client.statement.HttpResponse
import io.ktor.http.ContentType
import io.ktor.http.contentType

class DailyRewardsApi(private val client: HttpClient) {
    suspend fun getDailyRewards(): HttpResponse {
        return client.get("daily-rewards") {
            contentType(ContentType.Application.Json)
            expectSuccess = false
        }
    }

    suspend fun claimDailyReward(): HttpResponse {
        return client.post("daily-rewards/claim") {
            contentType(ContentType.Application.Json)
            expectSuccess = false
        }
    }
}